function updateTimer() {
  const now = new Date();
  const nextResetTime = new Date();
  nextResetTime.setHours(24, 0, 0, 0);
  const timeRemaining = nextResetTime - now;

  const hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((timeRemaining / (1000 * 60)) % 60);
  const seconds = Math.floor((timeRemaining / 1000) % 60);

  document.getElementById("hours").textContent = hours.toString().padStart(2, '0') + "h ";
  document.getElementById("minutes").textContent = minutes + "m ";
  document.getElementById("seconds").textContent = seconds + "s ";
}

setInterval(updateTimer, 1000);
updateTimer();

document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;
  const sizeGuideOverlay = document.querySelector(".size-guide__overlay");
  const sizeGuide = document.querySelector(".size-guide");

  body.addEventListener("click", (event) => {
    if (event.target.classList.contains("form-wrapper__show-size")) {
      sizeGuideOverlay.classList.add("active");
      sizeGuide.classList.add("active");
      body.classList.add("size-guide-open");
    }
  });

  body.addEventListener("click", (event) => {

    if (
      event.target.classList.contains("size-guide__close") ||
      event.target.classList.contains("size-guide__overlay") ||
      event.target.closest(".size-guide__cross")
    ) {
      sizeGuideOverlay.classList.remove("active");
      sizeGuide.classList.remove("active");
      body.classList.remove("size-guide-open");
    }
  });
});

const unitRadioButtons = document.querySelectorAll('input[name="unit"]');

function updateSizeVisibility() {
  const selectedUnit = document.querySelector(
    'input[name="unit"]:checked'
  ).value;
  const inSizeElements = document.querySelectorAll(".in-size");
  const cmSizeElements = document.querySelectorAll(".cm-size");

  inSizeElements.forEach((el) => {
    if (el.tagName.toLowerCase() === "span") {
      el.style.display = selectedUnit === "inches" ? "inline" : "none";
    } else {
      el.style.display = selectedUnit === "inches" ? "table" : "none";
    }
  });

  cmSizeElements.forEach((el) => {
    if (el.tagName.toLowerCase() === "span") {
      el.style.display = selectedUnit === "inches" ? "none" : "inline";
    } else {
      el.style.display = selectedUnit === "inches" ? "none" : "table";
    }
  });
}

function updateSizeVisibilityLeg() {
  const selectedUnit = document.querySelector(
    'input[name="unit"]:checked'
  ).value;
  const inSizeElements = document.querySelectorAll(".in-size-leg");
  const cmSizeElements = document.querySelectorAll(".cm-size-leg");

  inSizeElements.forEach((el) => {
    if (el.tagName.toLowerCase() === "span") {
      el.style.display = selectedUnit === "inches" ? "inline" : "none";
    } else {
      el.style.display = selectedUnit === "inches" ? "table-cell" : "none";
    }
  });

  cmSizeElements.forEach((el) => {
    if (el.tagName.toLowerCase() === "span") {
      el.style.display = selectedUnit === "inches" ? "none" : "inline";
    } else {
      el.style.display = selectedUnit === "inches" ? "none" : "table-cell";
    }
  });
}

unitRadioButtons.forEach((rb) => {
  rb.addEventListener("change", updateSizeVisibility);
});

updateSizeVisibility();

function initializeHoverEffect() {
  const elements = document.querySelectorAll(".product-media__right");

  elements.forEach((element) => {
    element.addEventListener("mouseenter", () => {
      element.classList.add("has-hovered");
    });
  });
}

document.addEventListener("DOMContentLoaded", initializeHoverEffect);
document.addEventListener("updateGallery", initializeHoverEffect);